import type { PropertyTemplate, TemplateAudience, TemplateScope } from '@/domain/entities/preperty-template';

export type ListTemplatesResponse = {
  templates: PropertyTemplate[];
  nextToken?: string | null;
};

export type CreateTemplatePayload = Pick<
  PropertyTemplate,
  'orgID' | 'status' | 'schemaRef' | 'title' | 'description' | 'data' | 'audience'
> & { scope: TemplateScope };

export type TemplateSortKey = 'title' | 'status' | 'updatedAt' | 'audience';
export type TemplateSortDir = 'asc' | 'desc';
export type TemplateListAudience = TemplateAudience | 'all';
type TemplateOrgListScopeKey = `org:${string}` | 'all-orgs';
export type TemplateListScopeKey = `${TemplateOrgListScopeKey}|audience:${TemplateListAudience}`;
export type TemplateOrgScope = 'active-org' | 'all-orgs';

export type UpdateTemplatePayload = Pick<PropertyTemplate, 'id'> &
  Partial<
    Pick<PropertyTemplate, 'scope' | 'orgID' | 'audience' | 'status' | 'schemaRef' | 'title' | 'description' | 'data'>
  >;

export type DeleteTemplateResponse = { ok: true } | { ok: boolean; message?: string };

export type UpsertPayload = { data?: PropertyTemplate };

export function makeTemplateListScopeKey(
  orgID?: string | null,
  audience: TemplateListAudience = 'all',
): TemplateListScopeKey {
  const normalizedOrgID = orgID?.trim();
  const orgScopeKey: TemplateOrgListScopeKey = normalizedOrgID ? `org:${normalizedOrgID}` : 'all-orgs';
  return `${orgScopeKey}|audience:${audience}`;
}
